// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plugin__loading {\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  left: 0;\n  top: 0;\n  background: rgba(255, 255, 255, 0.7);\n  font-size: 60px;\n}\n.application.theme--dark .plugin__loading {\n  background: rgba(0, 0, 0, 0.7);\n}", ""]);
// Exports
module.exports = exports;
